import React, { FC } from 'react';
import { IconButton } from '@material-ui/core';
import clsx from 'clsx';
import baseSlideControlStyles from './baseSlideControlStyles';
import { slickSliderUtilities } from '../../../../../productVariants/service/slickSliderUtilities';

export interface IBaseSliderControl {
  onClick: () => void;
  setIsUpdateFromSliderControls?: (bool: boolean) => void;
  className: string;
  customStyles?: string;
}

export interface ICustomStyles {
  default: string;
  rightArrow: string;
  leftArrow: string;
}

const BaseSliderControl: FC<IBaseSliderControl> = ({
  className,
  onClick,
  children,
  customStyles,
  setIsUpdateFromSliderControls,
}) => {
  const styles = baseSlideControlStyles();
  const arrowStyle = slickSliderUtilities.getArrowSliderClass(className, styles, customStyles);
  const buttonClick = () => {
    try {
      // onClick function comes from slick-slider
      onClick();
      if (setIsUpdateFromSliderControls) {
        setIsUpdateFromSliderControls(true);
      }
    } catch {
      /* tslint:disable-next-line:no-console */
      console.error('There was an error updating the slider index');
    }
  };

  return (
    <IconButton onClick={buttonClick} className={clsx(arrowStyle)}>
      {children}
    </IconButton>
  );
};

export default BaseSliderControl;
